import { ComponentProps, ReactNode } from 'react';

export const Button = <ElemType extends 'div' | 'button'>({
  children,
  buttonProps,
  onClick,
  disabled,
  variant = 'primary',
  elemType,
  className,
}: {
  elemType?: ElemType;
  onClick?: () => any;
  disabled?: any;
  buttonProps?: ComponentProps<ElemType>;
  variant?: 'primary' | 'gray' | 'darkGray' | 'red';
  children: ReactNode;
  className?: string;
}) => {
  const Component = elemType ?? 'button';

  // darkGray intentionally has no class entry and uses the empty fallback.
  const classes = `
    cursor-pointer
    rounded-lg
    tracking-[0.05em]
    py-2.5 px-6
    font-primary
    inline-flex
    items-center
    justify-center
    outline-none
    focus:outline-none
    transition-all
    hover:bg-opacity-90
    font-semibold
    ${disabled ? 'pointer-events-none opacity-20' : ''}
    ${className}

    ${
      (
        {
          primary: 'bg-primary text-white',
          gray: 'text-gray-1 bg-[#E1E5F0]',
          red: 'bg-red-700 text-white',
        } as Partial<Record<NonNullable<typeof variant>, string>>
      )[variant] ?? ''
    }
  `;

  return (
    <Component
      className={classes}
      onClick={onClick}
      disabled={disabled}
      type="button"
      {...(buttonProps as any)}
    >
      {children}
    </Component>
  );
};
